import { useContext } from "react";
import { GrowthBookContext } from "@growthbook/growthbook-react";

/** Resolves the paywall-at-intent arm, "control" outside a GrowthBook provider; `arm` is stamped onto analytics events. */
export function usePaywallAtIntent(): { keepGoing: boolean; arm: string } {
  const { growthbook } = useContext(GrowthBookContext);
  const arm = growthbook ? growthbook.getFeatureValue("paywall-at-intent", "control") : "control";
  return { keepGoing: arm === "keep_going", arm };
}
